<template>
  <div class="phd-invoice-form">
    <label class="ph-field ph-field--full">
      <span class="ph-field-label">Bill to (name) *</span>
      <input
        type="text"
        :value="local.invoice_name"
        @input="update('invoice_name', $event.target.value)"
        class="ph-field-input"
        autocomplete="name"
        required
      />
    </label>

    <label class="ph-field ph-field--full">
      <span class="ph-field-label">Send invoices to *</span>
      <input
        type="text"
        :value="local.invoice_emails"
        @input="update('invoice_emails', $event.target.value)"
        class="ph-field-input"
        placeholder="ap@yourco.com"
        required
      />
    </label>

    <label class="ph-field ph-field--full">
      <span class="ph-field-label">Address *</span>
      <input
        type="text"
        :value="local.invoice_address"
        @input="update('invoice_address', $event.target.value)"
        class="ph-field-input"
        autocomplete="address-line1"
        required
      />
    </label>

    <div class="ph-field-row">
      <label class="ph-field">
        <span class="ph-field-label">City *</span>
        <input
          type="text"
          :value="local.invoice_city"
          @input="update('invoice_city', $event.target.value)"
          class="ph-field-input"
          autocomplete="address-level2"
          required
        />
      </label>
      <label class="ph-field">
        <span class="ph-field-label">State *</span>
        <input
          type="text"
          :value="local.invoice_state"
          @input="update('invoice_state', $event.target.value)"
          class="ph-field-input"
          autocomplete="address-level1"
          required
        />
      </label>
      <label class="ph-field">
        <span class="ph-field-label">ZIP *</span>
        <input
          type="text"
          :value="local.invoice_zip"
          @input="update('invoice_zip', $event.target.value)"
          class="ph-field-input"
          autocomplete="postal-code"
          inputmode="numeric"
          maxlength="10"
          required
        />
      </label>
    </div>

    <div v-if="error" class="ph-demo-error" role="alert" aria-live="assertive">{{ error }}</div>
  </div>
</template>

<script>
const FIELDS = ['invoice_name', 'invoice_emails', 'invoice_address', 'invoice_city', 'invoice_state', 'invoice_zip'];

export default {
  name: 'InvoiceFieldsForm',

  // Two-way binding via v-model on a single object so the parent gets one
  // reactive blob to persist + send. Mirrors the legacy CompanyBillingInfo
  // Invoice payload shape (NewSignUp1.vue:530-544).
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    error: { type: String, default: '' },
  },

  computed: {
    local() {
      return {
        invoice_name: '',
        invoice_emails: '',
        invoice_address: '',
        invoice_city: '',
        invoice_state: '',
        invoice_zip: '',
        ...(this.value || {}),
      };
    },
  },

  methods: {
    update(field, val) {
      if (FIELDS.indexOf(field) === -1) return;
      this.$emit('input', { ...this.local, [field]: val });
    },
  },
};
</script>

<style lang="scss" scoped>
/* The .ph-field/.ph-field-input/.ph-field-label/.ph-field-row rules in
   PricingPage.vue are <style scoped>, so they don't reach this child
   component's elements. Mirror them here so the field layout (label
   above input, two-column rows on desktop) survives. */
.phd-invoice-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 6px;
}

/* .ph-field-* rules live in src/assets/scss/_ph-modal.scss now,
   imported globally from main.js. Don't redeclare here — superpowers
   review #2 flagged the previous duplication as drift risk. */
</style>
